import { IconProps } from "./types";

export const ImageIcon = (props: IconProps) => (
  <div></div>
);
